module.exports = __webpack_public_path__ + "img/01.96315f5b.png";